import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../../context/AuthContext";
import Loader from "../../../components/Loader";
import { useQuery } from "@tanstack/react-query";
import Table from "../../../components/Table";
import { Link } from "react-router-dom";
import { EquipementscolumnsLenovo } from "../../../components/headerContent";
import NumberCard from "../../../components/Card/NumberCard";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

export default function EquipementLenovo() {
  const { apiUrl, user } = useContext(AuthContext);
  const { t, i18n } = useTranslation();
  const [filteredData, setFilteredData] = useState([]);

  const getEquipementsLenovo = async () => {
    const res = await axios.get(`${apiUrl}lenovo/devices`, {
      withCredentials: true,
    });
    return res.data;
  };

  const EquipementsLenovo = useQuery({
    queryKey: ["EquipementsLenovo"],
    queryFn: getEquipementsLenovo
  });

  useEffect(() => {
    if (!EquipementsLenovo.isFetching && EquipementsLenovo.data && EquipementsLenovo.data.devices.length > 0) {
      setFilteredData(EquipementsLenovo.data.devices);
    }
  }, [EquipementsLenovo]);

  if (!EquipementsLenovo.isLoading && EquipementsLenovo.data && EquipementsLenovo.data.length === 0 || !EquipementsLenovo.isLoading && !EquipementsLenovo.data) {
    return (
      <div className="ecp-container">
        <div className="ecp-container-content-error">
          <div className="error-container">
            <img src='../assets/ecp_error.svg' alt="icône d'erreur" />
            <div className="error-container-text">
              <h1 className="page-title">
                {t("Aucun équipement disponible")}
              </h1>
              <p className="page-link_home">
                <Link to="/"> {t("Revenir à l'accueil")}</Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="ecp-container">
      <div className="ecp-container-content">
        {!EquipementsLenovo.isLoading && !EquipementsLenovo.isFetching ? (
          <>
            <div className="ecp-container-content-header">
              <div className="ecp-container-content-header-title">
                <div className="page-title page-logo">
                  <img src="../assets/lenovo.png" alt="Logo de Lenovo" />
                  <h1 className="page-title">{t("Equipements")} Lenovo</h1>
                </div>
              </div>
            </div>
            <section className="page-section">
              <NumberCard
                title={`${t("Nombre d'équipements disponibles")}`}
                number={
                  filteredData.length
                }
                logo={faCircleCheck}
                color={"#AEC353"}
                stylesIcons={"logo-certificats"}
              />
            </section>
            <div className='cato-content-table'>
              <Table
                tableData={
                  filteredData
                }
                tableColumns={EquipementscolumnsLenovo}
                sites={filteredData}
                holding={user.entrepriseId}
              />
            </div>
          </>
        ) : (
          <Loader />
        )}
      </div>
    </div>
  );
}
